import { useContext } from "react";
import { IMaterial } from "../../services/WebApiClient";
import { distinct } from "../../util/distinct";
import { EditorContext } from "../EditorCommon/EditorContext";
import { MaterialSelector } from "../EditorCommon/MaterialSelector";
import { BarCountSelector } from "./BarCountSelector";


export function SingleDoorEditor(props: {
    doorIndex: number,
    onClose: (() => void)
}) {
    const ec = useContext(EditorContext);

    const door = ec.cabinet.doors[props.doorIndex];
    if (!door) {
        props.onClose();
        return null;
    }
    const doorProduct = ec.cabinetService.getDoorProduct()
    if (!doorProduct) {
        props.onClose();
        return null;
    }
    const barProduct = door.barId ? ec.cabinetService.getDoorBar(door.barId, {}) : undefined;

    function setDoorMaterial(mat: IMaterial) {
        ec.cabinetService.setDoorMaterial(props.doorIndex, mat.id);
    }
    function setBandMaterial(mat: IMaterial) {
        ec.cabinetService.setBandMaterial(props.doorIndex, mat.id);
    }

    let bandMaterial = undefined;
    if (barProduct?.bandHeight !== null && doorProduct.bandMaterials.length > 0) {
        bandMaterial = (
            <li className="nav-item">
                <MaterialSelector
                    materials={doorProduct.bandMaterials}
                    currentId={door.bandMaterialId ?? undefined}
                    onSelect={setBandMaterial}
                    header={ec.translator("doors band material", "Pyntebånd materiale")}
                />
            </li>
        );
    }

    const barCountSelector = <BarCountSelector doorIndex={props.doorIndex} />;
    let barCount = undefined;
    if (barCountSelector) {
        barCount = (
            <li className="nav-item">
                {barCountSelector}
            </li>
        );
    }
    const doorSizes = doorProduct.doorSizes
        .filter(ds => ds.min.x <= door.size.x
            && ds.max.x >= door.size.x
            && ds.min.y <= door.size.y
            && ds.max.y >= door.size.y
        );
    const materials = distinct(doorSizes.map(ds => ds.material), mat => mat.id);



    return (
        <>
            <h3>
                {ec.translator("doors editor header", "Dør {index}", { index: (props.doorIndex + 1).toString() })}
            </h3>
            <ul className="nav flex-column single-door-editor">
                <li className="nav-item">
                    <MaterialSelector
                        materials={materials}
                        currentId={door.materialId}
                        onSelect={setDoorMaterial}
                        header={ec.translator("doors filling material", "Materiale")}
                    />
                </li>
                {barCount}
                {bandMaterial}

            </ul>
        </>
    );
}
